import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { PracticeLabReviewResponse } from "@/types/practice-lab";

// A review: the "was it done well" pass. Verdict prose, then the numbered flags
// to address, and an optional nice-touch note.
export function ReviewCard({
  review,
  stepOrder,
}: {
  review: PracticeLabReviewResponse;
  stepOrder: number;
}) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <CardTitle>Review · step {stepOrder}</CardTitle>
          <span className="inline-flex items-center rounded-full border border-green-200 bg-green-50 px-2.5 py-0.5 text-xs font-medium text-green-700 dark:border-green-800 dark:bg-green-950/30 dark:text-green-400">
            {review.checks_passed_count} / {review.checks_total} checks pass
          </span>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="break-words leading-relaxed">{review.prose}</p>
        {review.flags.length > 0 && (
          <ul className="space-y-3">
            {review.flags.map((flag, i) => (
              <li
                key={i}
                className="flex gap-3 border-t pt-3 text-sm leading-relaxed"
              >
                <span className="font-semibold text-amber-600 dark:text-amber-400">
                  {i + 1}
                </span>
                <span className="min-w-0 break-words">{flag}</span>
              </li>
            ))}
          </ul>
        )}
        {review.nice_touch && (
          <p className="break-words border-t pt-3 text-sm text-muted-foreground">
            Nice touch: {review.nice_touch}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
